import * as React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import {Dispatch, useState} from "react";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

interface trashType {
    name: string;
    id: string;
}

interface containerSize {
    id: string;
    name: string;
    photo: string
}

interface trashTypeWithSizesMap {
}

function fetchAllContainersOptions(apiUrl: string) {
    return new Promise<{
        trashTypes: trashType[],
        containerSizes: containerSize[],
        trashTypesWithSizesMap: trashTypeWithSizesMap[]
    }>((resolve, reject) => {
        const options = {
            method: 'POST'
        };

        fetch(apiUrl + 'containers-options-all')
            .then((res) => res.json())
            .then(({trashTypes, containerSizes, trashTypesWithSizesMap}) => {
                resolve({trashTypes, containerSizes, trashTypesWithSizesMap});
            });
    });
}

type requestFormProps = {
    showForm: boolean,
    translations: any,
    address: string,
    setOrderConfirmed: Dispatch<any>,
    hideSearchForm: boolean,
    apiUrl: string

};

export const RequestForm = ({
                                showForm,
                                translations,
                                address,
                                setOrderConfirmed,
                                hideSearchForm,
                                apiUrl
                            }: requestFormProps) => {
    const [open, setOpen] = React.useState(false);
    const [openAfter, setAfterOpen] = React.useState(false);
    const requestAbortController = React.useRef<AbortController | null>(null);
    const [nameSurname, setNameSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [nameSurNameError, setNameSurnameError] = useState(false);
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [trashTypeError, setTrashTypeError] = useState(false);
    const [containerSizeError, setContainerSizeError] = useState(false);
    const [trashType, setTrashType] = useState('');
    const [containerSize, setContainerSize] = useState('');
    const [trashTypes, setTrashTypes] = useState<trashType[]>([]);
    const [trashTypesWithSizesMap, setTrashTypesWithSizesMap] = useState([]);
    const [containerSizes, setContainerSizes] = useState<containerSize[]>([]);
    const [trashTypeSizesMap, setTrashTypeSizesMap] = useState<trashTypeWithSizesMap[]>(['-']);

    const handleClose = () => {
        setOpen(false);
        setAfterOpen(false);
    };

    const submitOrder = (event: any) => {
        event.preventDefault();
        const formDetails = {
            trashType: trashType,
            containerSize: containerSize,
            address: address,
            nameSurname: nameSurname,
            email: email,
            phoneNumber: phoneNumber,
            message: message,
        };

        let valid = true;

        if (!trashType || trashType.length == 0) {
            setTrashTypeError(true);
            valid = false;
        } else {
            setTrashTypeError(false);
        }

        if (!containerSize || containerSize.length == 0) {
            setContainerSizeError(true);
            valid = false;
        } else {
            setContainerSizeError(false);
        }

        const emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");

        if (!emailRegex.test(email)) {
            setEmailError(true);
            valid = false;
        } else {
            setEmailError(false);
        }

        if (!nameSurname || nameSurname.length < 10) {
            setNameSurnameError(true);
            valid = false;
        } else {
            setNameSurnameError(false);
        }

        // const phoneRegex = /^(?:\+370)([5-9]\d{7})$/;
        // if (!phoneRegex.test(phoneNumber)) {
        //     setPhoneNumberError(true);
        //     valid = false;
        // } else {
        //     setPhoneNumberError(false);
        // }

        if (valid) {
            const options = {
                method: 'POST',
                body: JSON.stringify(formDetails)
            };

            fetch(
                apiUrl + "create-on-request-order", options)
                .then((res) => res.json())
                .then((daysToHighlight) => {
                    if (hideSearchForm) {
                        const box = document.getElementById('order-form');
                        box.style.display = 'none';
                    }
                    setOrderConfirmed(true);
                    setOpen(false);
                    if (!hideSearchForm) {
                        setAfterOpen(true);
                    }
                });
        }
    }


    const handleContainerSizeSelection = (event) => {
        if (event.target.value == '-') {
            setContainerSize('');
        } else {
            setContainerSize(event.target.value);
        }
        const item = containerSizes.filter(containerSizeItem => containerSizeItem.id == event.target.value);
    }

    const handleTrashTypeSelection = (event: any) => {
        if (event.target.value == '-') {
            setTrashType('');
        } else {
            setTrashType(event.target.value);
            setTrashTypeSizesMap(trashTypesWithSizesMap[event.target.value]);
        }
    }

    React.useEffect(() => {
        if (showForm) {
            setOpen(true);
        }
        // abort request on unmount
        return () => requestAbortController.current?.abort();
    }, [showForm]);

    const fetchAllContainersOptionsData = () => {
        const controller = new AbortController();
        fetchAllContainersOptions(apiUrl)
            .then(({trashTypes, containerSizes, trashTypesWithSizesMap}) => {
                setTrashType('');
                setContainerSize('');
                setTrashTypes(trashTypes);
                setContainerSizes(containerSizes);
                setTrashTypesWithSizesMap(trashTypesWithSizesMap);
            })
            .catch((error) => {
                // ignore the error if it's caused by `controller.abort`
                if (error.name !== 'AbortError') {
                    throw error;
                }
            });

        requestAbortController.current = controller;
    };


    React.useEffect(() => {
        fetchAllContainersOptionsData();
        // abort request on unmount
        return () => requestAbortController.current?.abort();
    }, []);

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth={'md'}
            >
                <DialogTitle sx={{m: 0, p: 2, mr: 5}} id="customized-dialog-title">
                    {translations.available_containers_by_give_address_not_found}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent dividers>
                    <span className="pb20 dib">{translations.fill_a_form_and_we_will_contact}</span>
                    <div>
                        <input type={"text"} disabled={true} value={address} className="form-control"
                               id="addressField" placeholder={translations.address}/>
                    </div>

                    <div>
                        <select style={trashTypeError ? {borderColor: 'red'} : {}} name="trashType" id="trashType"
                                className="form-control"
                                onChange={handleTrashTypeSelection} placeholder={translations.trash_type}>
                            {trashTypes.map(trashType =>
                                <option value={trashType.id} key={trashType.id}>{trashType.name}</option>
                            )}
                        </select>
                    </div>
                    <div>
                        <select style={containerSizeError ? {borderColor: 'red'} : {}} name="containerSize"
                                id="containerSize" className="form-control"
                                onChange={handleContainerSizeSelection} placeholder={translations.container_size}>
                            {containerSizes.map(containerSize => {
                                    if (trashTypeSizesMap.includes(containerSize.id)) {
                                        return <option value={containerSize.id}
                                                       key={containerSize.id}>{containerSize.name}</option>
                                    } else {
                                        return null;
                                    }
                                }
                            )}
                        </select>
                    </div>

                    <div>
                        <input style={nameSurNameError ? {borderColor: 'red'} : {}}
                               value={nameSurname}
                               onChange={e => setNameSurname(e.target.value)}
                               className="form-control"
                               id="name-surname"
                               placeholder={translations.name_surname_company_name}
                        />
                    </div>
                    <div>
                        <input
                            style={emailError ? {borderColor: 'red'} : {}}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            className="form-control"
                            id="email-address"
                            placeholder={translations.email}
                        />
                    </div>
                    <div>
                        <input
                            style={phoneNumberError ? {borderColor: 'red'} : {}}
                            value={phoneNumber}
                            onChange={e => setPhoneNumber(e.target.value)}
                            className="form-control"
                            placeholder={translations.phone_number}
                            id="phone-number"
                        />
                    </div>
                    <div>
                        <textarea id="individual-message" className="form-control" value={message}
                                  onChange={e => setMessage(e.target.value)}
                                  placeholder={translations.individual_message}/>
                    </div>
                    <br/>
                    <div>
                        <button type="submit" className="w-100 btn btn-primary btn-lg"
                                onClick={submitOrder}>{translations.send_container_request}</button>
                    </div>
                </DialogContent>
            </BootstrapDialog>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openAfter}
                maxWidth={'md'}
            >
                <DialogTitle sx={{m: 0, p: 2, mr: 5}} id="customized-dialog-title">
                    {translations.on_request_order_created}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </BootstrapDialog>
        </>
    );
}
